import { ReactNode } from 'react'
import styles from './Stack.module.css'

/** 시안 `.stack` 이식. gap 은 프리셋 10px, `gap`/`align` 은 인라인으로 덮어쓴다. */
export type StackProps = {
  gap?: number
  align?: 'stretch' | 'flex-end'
  children: ReactNode
}

export const Stack = ({ gap = 10, align, children }: StackProps): JSX.Element => (
  <div className={styles.stack} style={{ gap, alignItems: align }}>
    {children}
  </div>
)
